<template>
  <span style="display: inline-block; vertical-align: middle;">
    <b-dropdown
      variant="outline-primary"
      size="sm"
      :style="alterarStyle"
      toggle-class="d-inline-flex align-items-center"
      right
    >
      <template #button-content>
        <feather-icon
          icon="SendIcon"
          class="text-primary"
          size="15"
        />
        Enviar por e-mail
      </template>
      <b-dropdown-item
        v-for="opcao in opcoesDestinatario"
        :key="opcao.value"
        @click="selecionarDestinatario(opcao.value)"
      >
        {{ opcao.label }}
      </b-dropdown-item>
    </b-dropdown>

    <b-modal
      ref="modalEnviarEmail"
      size="lg"
      no-close-on-backdrop
      :hide-header-close="true"
    >
      <template #modal-title>
        <h3 style="word-break: break-all;">
          {{ title }} para {{ getQuantidadeEmpresas() }} empresa{{ getQuantidadeEmpresas() > 1 ? 's' : '' }}
        </h3>
      </template>
      <div style="margin-top: 20px;">
        <label for="mensagens-adicional">Mensagem adicional</label>
        <b-form-textarea
          v-model="mensagemAdicional"
          style="height: 10rem;"
          input-id="mensagens-adicional"
        />
      </div>

      <template #modal-footer>
        <b-btn
          variant="none"
          size="sm"
          class="btn-outline-success btn-none"
          style="margin-left: 0.3rem;"
          @click="enviarEmailLoteGeral"
        >
          Enviar
        </b-btn>
        <b-btn
          variant="none"
          size="sm"
          class="btn-outline-danger btn-none"
          style="margin-left: 0.3rem;"
          @click="$refs.modalEnviarEmail.hide()"
        >
          Cancelar
        </b-btn>
      </template>

    </b-modal>

    <empresas-sem-email
      ref="empresaSemEmailList"
      v-model="empresasSemEmail"
      @confirmar-envio="abrirModalMensagemAdicional(empresasSemEmail)"
    />

    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :descricao="'Enviando email'"
    />
  </span>
</template>

<style lang="scss">
</style>

<script>

export default {
  name: 'EnvioEmailEmLote',
  components: {
    EmpresasSemEmail: () => import('./EmpresaSemEmail.vue'),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
  },
  props: {
    title: {
      type: String,
      default: 'Envio de email',
    },
    empresasSelecionadas: {
      type: Array,
      default: null,
    },
    empresasGrid: {
      type: Array,
      required: true,
    },
    alterarStyle: {
      type: String,
      default: 'white-space: nowrap;',
    },
    evento: {
      type: Function,
      default: null,
    },
    eventoVerificarEmail: {
      type: Function,
      default: null,
    },
    nomeArquivo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mensagemAdicional: null,
      empresasSemEmail: [],
      isLoading: false,
      tipoDestinatario: null,
      opcoesDestinatario: [
        { value: 'principal', label: 'Apenas e-mail principal' },
        { value: 'adicional', label: 'Apenas e-mail adicional' },
        { value: 'ambos', label: 'Ambos os e-mails' },
      ],
    }
  },
  created() {
  },
  methods: {
    /**
     * Armazena o tipo de destinatário selecionado e inicia o fluxo de verificação de emails.
     * @param {string} tipo - Tipo de destinatário: 'principal', 'adicional' ou 'ambos'
     */
    selecionarDestinatario(tipo) {
      this.tipoDestinatario = tipo
      this.verificarEmail()
    },
    getQuantidadeEmpresas() {
      return this.empresasSelecionadas.length > 0 ? this.empresasSelecionadas.length : this.empresasGrid.length
    },
    abrirModalMensagemAdicional(empresasSemEmail) {
      this.mensagemAdicional = null
      this.empresasSemEmail = empresasSemEmail

      const listaIds = this.empresasSelecionadas.length > 0 ? this.empresasSelecionadas : this.empresasGrid.map(empresa => empresa.id)

      if (listaIds.length > this.empresasSemEmail.length || empresasSemEmail.filter(empresa => empresa.email !== null && empresa.email.filter(email => email !== '').length > 0).length > 0) {
        this.$refs.modalEnviarEmail.show()
      } else {
        this.$aviso('Não foi possível continuar: nenhuma empresa possui e-mail.')
      }
    },
    verificarEmail() {
      const ids = this.empresasSelecionadas.length > 0 ? this.empresasSelecionadas : this.empresasGrid.map(empresa => empresa.id)

      this.eventoVerificarEmail(ids)
        .then(payload => {
          if (payload.data !== undefined && payload.data.length > 0) {
            this.empresasSemEmail = payload.data
            this.$refs.empresaSemEmailList.show()
          } else {
            this.abrirModalMensagemAdicional([])
          }
        })
    },
    enviarEmailLoteGeral() {
      this.$refs.modalEnviarEmail.hide()

      const empresaEmail = this.empresasGrid.map(empresa => ({
        empresaId: empresa.id,
        emailsCC: null,
        email: empresa.emailEmpresa ? empresa.emailEmpresa : null,
        mensagensAdicional: this.mensagemAdicional,
      }))

      if (this.empresasSemEmail !== undefined) {
        this.empresasSemEmail.forEach(empresa => {
          empresaEmail.push({
            empresaId: empresa.id,
            emailsCC: null,
            email: empresa.email ? empresa.email : null,
            mensagensAdicional: this.mensagemAdicional,
            definirEmailPadrao: true,
          })
        })
      }

      this.isLoading = true

      this.evento(this.nomeArquivo, {
        docs: [],
        empresas: this.empresasSelecionadas,
        empresasEmail: [...empresaEmail],
        tipoDestinatario: this.tipoDestinatario,
      }).then(payload => {
        if (payload.data.length > 0) {
          this.$erro(`Erro ao enviar os emails das seguintes empresas: ${payload.data.join(', ')}`)
        } else {
          this.$sucesso('E-mails enviados com sucesso')
        }
      }).catch(err => {
        this.$erro('Erro ao enviar os e-mails')
        throw err
      }).finally(() => {
        this.isLoading = false
      })
    },
  },

}
</script>
